import VueRouter from 'vue-router'
import store from "@/store";
import Vue from 'vue'
Vue.use(VueRouter)

const ifAuth = async (to, from, next) =>{
    let token = localStorage.getItem('token') || null;
    if(token == null) return next ( {name: 'land'} )
    store.dispatch('fetchCompanyInfo')
        .then(()=>{
            if (to.meta.permission) {
              if (!store.getters.getCompany.permissions.includes(to.meta.permission)) {
                return next ( {name: 'main'} );
              }
            }
            next();
        })
}
const Driver = async(to, from, next) => {
    let token = localStorage.getItem('token') || null;
    if(token != null){
        store.dispatch('fetchCompanyInfo')
            .then(()=>{
                next();
            })
    }else{
        store.commit('setGLoading', false)
        next()
    }

}
const noAuth = (to,from,next) => {
    let token = localStorage.getItem('token') || null;
    if(token == null) {
        next ()
        return store.commit('setGLoading', false)
    }
    store.dispatch('fetchCompanyInfo')
        .then(()=>{
            next({name: 'main'});
        })
}
const routes = [
    {
        path: '*',
        redirect: {name: 'main'},
        beforeEnter: Driver,
    },
    {
        path: '/auth',
        beforeEnter: noAuth,
        component: () => import("@/layout/auth-layout"),
        meta: {
            hideSidebar: true,
            hideHeader: true
        },
        children:[
            {
                path: '',
                redirect: {name: 'login'},
            },
            {
                path: 'login',
                name: 'login',
                component: () => import("@/pages/auth/login.vue"),
                meta: {
                    title: 'Вход',
                }
            },
            {
                path: 'registration',
                name: 'reg',
                component: () => import("@/pages/auth/registration.vue"),
                meta: {
                    title: 'Регистрация',
                }
            },
            {
                path: 'recover',
                name: 'rec',
                component: () => import("@/pages/auth/recover.vue"),
                meta: {
                    title: 'Восстановление пароля',
                }
            }

        ]
    },
    {
        path: '/session/:token',
        name: 'sess',
        component: () => import("@/pages/auth/session.vue"),
        meta: {
          hideSidebar: true,
          hideHeader: true
        },
    },
    {
        path: '/',
        name: 'land',
        component: () => import('@/pages/landing'),
        beforeEnter: noAuth,
    },
    {
        path: '/',
        component: () => import('@/layout/main-layout'),
        redirect: {name: 'main'},
        beforeEnter: ifAuth,
        children: [
            {
                path: '/shops',
                name: 'shops',
                component: () => import("@/pages/shops"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Магазины',
                }
            },
            {
                path: '/blog',
                name: 'blog',
                component: () => import("@/pages/blog"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Дискуссионный клуб',
                }
            },
            {
                path: '/post/:id',
                name: 'post',
                component: () => import("@/pages/post"),
                beforeEnter: ifAuth,
                meta: {
                    title: null,
                    back2: 'blog',
                }
            },
            {
                path: '/item/:id',
                name: 'item',
                component: () => import("@/pages/item"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Товар',
                    back1: 'MyItems',
                    back2: 'MyItems',
                    backHistory: true
                }
            },
            {
                path: '/product/:id',
                name: 'product',
                component: () => import("@/pages/product"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Товар',
                    back2: 'items',
                    backHistory: true
                }
            },
            {
                path: '/users',
                component: () => import("@/pages/worker/edit.vue"),
                name: 'users',
                beforeEnter: ifAuth,
                meta: {
                    title: 'Сотрудники',
                    permission: 'page.users'
                }
            },
            {
                path: '/invites',
                component: () => import("@/pages/invite.vue"),
                name: 'invites',
                beforeEnter: ifAuth,
                meta: {
                    title: 'Приглашения',
                    permission: 'page.users'
                }
            },
            {
                path: '/chat',
                component: () => import("@/pages/chat.vue"),
                name: 'chat',
                beforeEnter: ifAuth,
                meta: {
                    title: 'Чаты'
                }
            },
            {
                path: '/notes',
                component: () => import("@/pages/notes"),
                name: 'notes',
                beforeEnter: ifAuth,
                meta: {
                    title: 'Блокнот'
                }
            },
            {
                path: '/',
                component: () => import("@/pages/home.vue"),
                name: 'main',
                beforeEnter: ifAuth,
                meta: {
                    title: 'Главная'
                }
            },
            {
                path: '/worker/profile',
                name: 'wprofile',
                component: () => import("@/pages/worker/profile.vue"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мой профиль'
                }
            },
            {
                path: '/worker/edit',
                name: 'wedit',
                component: () => import("@/pages/worker/edit.vue"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Сотрудники',
                    permission: 'page.users'
                }
            },
            {
                path: '/worker/add',
                name: 'wadd',
                component: () => import("@/pages/worker/add.vue"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Добавить сотрудника',
                    back1: 'users',
                    back2: 'users',
                    permission: 'page.users'
                }
            },
            {
                path: '/organization/edit',
                name: 'oedit',
                component: () => import("@/pages/organization/edit"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/organization/add',
                name: 'oadd',
                component: () => import("@/pages/organization/add"),
                beforeEnter: ifAuth,
                meta: {
                    title: localStorage.getItem('type') == 1 ? 'Добавить закупщика' : 'Добавить поставщика',
                    back2: 'osup',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/organization/requisites',
                name: 'oreq',
                component: () => import("@/pages/organization/requisites"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Реквизиты',
                    permission: 'page.organization.profile'
                }
            },
            /*{
                path: '/organization/suppliers',
                name: 'osup',
                component: () => import("@/pages/organization/suppliers"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Поставщики',
                    permission: localStorage.getItem('type') == 2 ? 'page.partners' : 'denied'
                }
            },*/
            {
                path: '/purchaser-orders',
                name: 'opur',
                component: () => import("@/pages/organization/purchase"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои заказы'
                }
            },
            {
                path: '/dropshipping-commission',
                name: 'drcom',
                component: () => import("@/pages/dropshipping-commission"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Комиссия'
                }
            },
            {
                path: '/dropshipping-purchasers',
                name: 'drpurchasers',
                component: () => import("@/pages/dropshipping-purchasers"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Закупщики'
                }
            },
            {
                path: '/provider-orders',
                name: 'prord',
                component: () => import("@/pages/organization/provider-order"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои заказы'
                }
            },
            {
                path: '/dropshipping-purchaser-orders',
                name: 'dropur',
                component: () => import("@/pages/organization/purchase"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои заказы (дропшиппинг)'
                }
            },
            {
                path: '/dropshipping-provider-orders',
                name: 'drprord',
                component: () => import("@/pages/organization/provider-order"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои заказы (дропшиппинг)'
                }
            },
            {
                path: '/order/:id/edit',
                name: 'opured',
                component: () => import("@/pages/organization/purchase-edit"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Редактировать заказ',
                    back1: 'prord',
                    back2: 'opur'
                }
            },
            /*{
                path: '/organization/clients',
                name: 'clients',
                component: () => import("@/pages/organization/clients"),
                beforeEnter: ifAuth,
                meta: {
                  title: 'Мои клиенты',
                  permission: localStorage.getItem('type') == 1 ? 'page.partners' : 'denied'
                }
            },*/
            {
                path: '/partners',
                name: 'partners',
                component: () => import("@/pages/partners"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои партнеры',
                    permission: ''
                }
            },
            {
                path: '/contracts',
                name: 'contracts',
                component: () => localStorage.getItem('type') == 1 ? import("@/pages/organization/clients") : import("@/pages/organization/suppliers"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои договоры',
                    permission: ''
                }
            },
            {
                path: '/organization/profile',
                name: 'oprof',
                component: () => import("@/pages/organization/profile"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/company/add',
                name: 'companyAdd',
                component: ()=> import("@/pages/organization/editAddCompany"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Добавить контрагента',
                    back2: 'oprof',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/company/edit/:id',
                name: 'companyEdit',
                component: () => import("@/pages/organization/editAddCompany"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации',
                    back2: 'oprof',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/entity/:id/view',
                name: 'viewentity',
                component: ()=> import("@/pages/organization/entity-view"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации',
                    back2: 'oprof',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/entity/:id',
                name: 'viewinfoentity',
                component: ()=> import("@/pages/organization/profile-entity"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации'
                }
            },
            {
                path: '/store/add',
                name: 'addStorePoint',
                component: () => import("@/pages/organization/editAddStore"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Добавить торговую точку',
                    back2: 'storePoints',//пишем имя роута на который надо будет возвращать
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/store/edit/:id',
                name: 'editStorePoint',
                component: () => import("@/pages/organization/editAddStore"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Редактировать торговую точку',
                    back2: 'storePoints',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/store/view/:id',
                name: 'viewStorePoint',
                component: ()=> import("@/pages/organization/view-store"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Детали торговой точки',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/contract/history/:id',
                name: 'contractHistory',
                component: ()=> import("@/pages/organization/contract-history"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'История договора',
                    back1: 'clients',//по типам сделано
                    back2: 'osup',//по типам сделано
                    backHistory: true
                }
            },
            {
                path: '/organization/store',
                name: 'storePoints',
                component: ()=> import("@/pages/organization/store"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Торговые точки',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/organization/rates',
                name: 'orts',
                component: () => import("@/pages/organization/rates"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль организации',
                    permission: 'page.organization.profile'
                }
            },
            {
                path: '/profile/:id',
                name: 'profile',
                component: () => import("@/pages/organization/contragent"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Профиль',
                    back1: 'contracts',//по типам сделано
                    back2: 'osup',//по типам сделано
                    backHistory: true
                }
            },
            {
                path: '/categories',
                name: 'categories',
                component: () => import("@/pages/items/categories"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Каталог'
                }
            },
            {
                path: '/myitems',
                name: 'MyItems',
                component: () => import("@/pages/items/my-items"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Мои товары'
                }
            },
            {
                path: '/items',
                name: 'Items',
                component: () => import("@/pages/items/purchaser-items"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Каталог всех товаров'
                }
            },
            {
                path: '/order',
                name: 'OrderForm',
                component: () => import("@/pages/items/order-form"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Форма заказа'
                }
            },
            {
                path: '/offers',
                name: 'Offers',
                component: () => import("@/pages/offers"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Коммерческие предложения'
                }
            },
            {
                path: '/offer',
                name: 'Offer',
                component: () => import("@/pages/offer"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'КП N 3450033'
                }
            },
            {
                path: '/offer/create',
                name: 'Offer_Create',
                component: () => import("@/pages/offer"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Создать КП',
                    back1: 'Offers',
                }
            },
            {
                path: '/dropshipping',
                name: 'Dropshipping',
                component: () => import("@/pages/dropshipping"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Дропшиппинг',
                    permission: 'page.dropshipping.permission'
                }
            },
            {
                path: '/provider-commission',
                name: 'drcompur',
                component: () => import("@/pages/dropshipping"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Комиссии',
                    permission: 'page.dropshipping.permission'
                }
            },
            {
                path: '/provider-commission/:id',
                name: 'drcomprov',
                component: () => import("@/pages/provider-commission"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Комиссии',
                    back2: 'drcompur'
                }
            },
            {
                path: '/dropshipping-categories',
                name: 'drcat',
                component: () => import("@/pages/dropshipping-categories"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Категории',
                    permission: ''
                }
            },
            {
                path: '/offer/:id/edit',
                name: 'Offer_Edit',
                component: () => import("@/pages/offer"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'КП N',
                    back1: 'Offers',
                }
            },
            {
                path: '/offer/:id',
                name: 'Offer',
                component: () => import("@/pages/offer"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'КП N ',
                    back1: 'Offers',
                    back2: 'Offers',
                }
            },
            {
                path: '/brands',
                name: 'brands',
                component: () => import("@/pages/brands"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Бренды',
                    permission: ''
                }
            },
            {
                path: '/import-logs',
                name: 'Import_logs',
                component: () => import("@/pages/import-log"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Логи импорта',
                    permission: ''
                }
            },
            {
                path: '/log/:id/errors',
                name: 'Import_log_errors',
                component: () => import("@/pages/import-log-errors"),
                beforeEnter: ifAuth,
                meta: {
                    title: 'Просмотр лога',
                    back1: 'Import_logs',
                    permission: ''
                }
            },
            {
                path: '/xxx',
                name: 'force'
            }
        ]
    },
]

const router = new VueRouter({
    routes: routes,
    mode: 'history'
})
router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || 'Superbaer24'
    })
})


export default router
